import { EntityDataUsuario } from '../../../../shared/Domain/EntityDataUsuario'
import { RepositoryMain } from '../Domain/RepositoryMain'
import { DtoTrabajos } from '../../../../Master/Home/Domain/DtoTrabajos'

export class UseCaseRepairMaterialUtilizadoObra {
  private repository: RepositoryMain
  private user: EntityDataUsuario
  private trabajo: DtoTrabajos

  constructor(_repository: RepositoryMain) {
    this.repository = _repository
    this.user = {} as EntityDataUsuario
    this.trabajo = {} as DtoTrabajos
  }

  public async exec(data: { user: EntityDataUsuario, trabajo: DtoTrabajos }) {
    this.user = data.user
    this.trabajo = data.trabajo
    return await this._exec()
  }

  private async _exec() {
    const params: any = {
      Header: {
        Coleccion: {
          Codigo: this.user.Delegacion.Codigo,
          Nombre: this.user.Pais.Nombre
        }
      },
      Body: {
        Pais: this.user.Pais,
        Delegacion: this.user.Delegacion,
        ID_GOM: this.trabajo.ID_GOM
      },
      ID_Trabajo: this.trabajo.ID_Trabajo
    }
    await this.repository.repairMaterialUtilizadoObra(params, this.user)
  }
}